var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"leave-active-class":"transition ease-in duration-1000","leave-class":"opacity-100","leave-to-class":"opacity-0"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.on),expression:"on"}],staticClass:"text-sm text-gray-600"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }